import { useState, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import Form from 'react-bootstrap/Form';
import CompetitionStatus from '../../Competitions/CompetitionStatus';
import NavMenu from '../../navMenu/NavMenu';
import PageTitle from '../../../components/PageTitle';
import EmptyState from '../../../components/EmptyState';
import RegistrationsTable from './RegistrationsTable';
import { getRegistrations } from '../../../api/Registrations';
import { getCompetition } from '../../../api/Competitions';
import AddRegistrationModal from './AddRegistrationModal';
import AddRegistrationButton from './AddRegistrationButton';
import Loading from '../../../components/Loading';
import CustomToast from '../../../components/CustomToast';
import DownloadButton from '../../../components/Buttons/DownloadButton';
import { generateRegistrations } from '../../../api/Assets';
import RegistrationCardContainer from './RegistrationCardContainer';
import BulkActionMenu from '../../../components/BulkActionMenu';
import RegistrationBulkMenuBtns from './RegistrationBulkMenuBtns';
import RaceClassBulkModal from './RaceClassBulkModal';

function CompetitionRegistrations() {
  const [registrations, setRegistrations] = useState();
  const [filteredRegistrations, setFilteredRegistrations] = useState();
  const [competition, setCompetition] = useState({});
  const [competitionName, setCompetitionName] = useState('');
  const [showAddRegistrationSuccess, setShowAddRegistrationSuccess] =
    useState(false);
  const [showAddRegistrationFail, setShowAddRegistrationFail] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [loading, setLoading] = useState(true);
  const [downloading, setDownloading] = useState(false);
  const [showDownloadFail, setShowDownloadFail] = useState(false);
  const [downloadError, setDownloadError] = useState('');
  const [search, setSearch] = useState('');
  const [raceClassBulkInfo, setRaceClassBulkInfo] = useState(null);
  const { id: competitionId } = useParams();
  const location = useLocation();

  const [batchSelectedRegistrations, setBatchSelectedRegistrations] = useState(
    []
  );
  const [bulkRegistrationStatusesSuccess, setBulkRegistrationStatusesSuccess] =
    useState({
      show: false,
      headerText: '',
      bodyText: '',
    });

  const [registrationStatusesFailToast, setRegistrationStatusesFailToast] =
    useState({ show: false });

  const [bulkRaceClassToast, setBulkRaceClassToast] = useState({
    show: false,
  });
  const [bulkStartlistToast, setBulkStartlistToast] = useState({ show: false });

  const PAGE_SIZE = 20;

  useEffect(() => {
    async function fetchData() {
      if (
        location.state === null ||
        Object.keys(location?.state?.competition).length === 0
      ) {
        const data = await getCompetition(competitionId);
        if (data) {
          setCompetition(data.competition);
          setCompetitionName(data.competition.basicInformation?.name);
        }
      } else {
        setCompetition(location.state.competition);
        setCompetitionName(location.state.competition.basicInformation?.name);
      }

      const registrations = await getRegistrations(competitionId);
      if (registrations) {
        setRegistrations(registrations.registered);
        setLoading(false);
      }
    }

    fetchData();
  }, [modalShow]);

  useEffect(() => {
    if (registrations) {
      filterRegistrations(search);
    }
  }, [registrations, search]);

  const filterRegistrations = (value) => {
    const allRegistrations = registrations;
    const filtered = allRegistrations.filter(
      (r) =>
        r.name?.toLowerCase().includes(value.toLowerCase()) ||
        r.clubAffiliation?.toLowerCase().includes(value.toLowerCase()) ||
        r.supporter?.name?.toLowerCase().includes(value.toLowerCase()) ||
        r.raceClass?.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredRegistrations(filtered);
  };

  const onDownloadRegistrations = async () => {
    setDownloading(true);
    const result = await generateRegistrations(competitionId);
    if (typeof result === 'object' && result !== null) {
      const url = window.URL.createObjectURL(new Blob([result]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Anmalningar.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      setDownloading(false);
    } else if (typeof result === 'string') {
      setDownloadError(result);
      setShowDownloadFail(true);
      setDownloading(false);
    }
  };

  const addRegistrationBtn = (
    <>
      {( competition?.status === 'Kommande' || competition?.status === 'Pågående' ) ? (
        <AddRegistrationButton
          onClick={() => setModalShow(true)}
          className='w-50'
        />
      ) : (
        <AddRegistrationButton
          onClick={() => setModalShow(true)}
          className='w-50'
          disabled={true}
        />
      )}
    </>
  );

  return (
    <div>
      <Row>
        <Col>
          <div className='d-flex flex-row gap-4 gap-md-4 gap-lg-5'>
            <div className='d-flex align-items-center'>
              <PageTitle
                title={competitionName}
                includeLinkBack={true}
                linkBackUrl='/organizer/competitions'
                includeStatus={
                  <CompetitionStatus
                    status={competition?.status}
                    id={competitionId}
                  />
                }
              />
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <NavMenu competition={competition} />
        </Col>
      </Row>
      <Row>
        <Col className='d-flex flex-column flex-md-row justify-content-between'>
          <div style={{ flexBasis: '50%' }}>
            <h4>Anmälningar</h4>
            <p className='text-secondary'>
              Samtliga mottagna anmälningar till tävlingen. Ange när
              anmälningsavgiften är betald och flytta över till startlista när
              den tävlande är incheckad.
            </p>
          </div>
          <div>
            {registrations?.length > 0 ? (
              <DownloadButton
                text='Ladda ner anmälningslista'
                className='w-100'
                loading={downloading}
                onClick={onDownloadRegistrations}
              />
            ) : (
              <DownloadButton
                text='Ladda ner anmälningslista'
                className='w-100'
                disabled={true}
              />
            )}
          </div>
        </Col>
      </Row>
      <Row className='mt-4'>
        <Col
          md={4}
          lg={4}
          xl={3}
          xxl={2}
          className='d-flex justify-content-between'
        >
          {( competition?.status === 'Kommande' || competition?.status === 'Pågående' ) ? (
            <AddRegistrationButton
              onClick={() => setModalShow(true)}
              className='w-100'
            />
          ) : (
            <AddRegistrationButton
              onClick={() => setModalShow(true)}
              className='w-100'
              disabled={true}
            />
          )}
        </Col>
        <Col
          md={{ offset: 4, span: 4 }}
          lg={{ offset: 4, span: 4 }}
          xl={{ offset: 5, span: 4 }}
          xxl={{ offset: 7, span: 3 }}
        >
          <Form.Control
            className='rounded-pill mt-4 mt-md-0'
            placeholder='Sök'
            onChange={(e) => setSearch(e.target.value)}
          />
        </Col>
      </Row>
      <Row>
        {loading ? (
          <div className='d-flex justify-content-center align-items-center mt-5'>
            <Loading size='100px' text='Laddar anmälningar' />
          </div>
        ) : filteredRegistrations && filteredRegistrations.length > 0 ? (
          <>
            {' '}
            <Col className='d-none d-xl-flex mt-2'>
              {
                <RegistrationsTable
                  registrations={filteredRegistrations}
                  status={competition?.status}
                  setRegistrations={setRegistrations}
                  rowsPerPage={PAGE_SIZE}
                  batchSelectedRegistrations={batchSelectedRegistrations}
                  setBatchSelectedRegistrations={setBatchSelectedRegistrations}
                />
              }
            </Col>
            <Col className='d-flex flex-column d-xl-none mt-4'>
              <RegistrationCardContainer
                rowsPerPage={PAGE_SIZE}
                batchSelectedElements={batchSelectedRegistrations}
                data={registrations}
                setData={setRegistrations}
                setBatchSelectedElements={setBatchSelectedRegistrations}
                competitionStatus={competition?.status}
              ></RegistrationCardContainer>
            </Col>
          </>
        ) : registrations.length === 0 ? (
          <EmptyState
            headingText={'Inga anmälningar än'}
            bodyText='När anmälningar kommer in visas de här. Du kan också lägga till anmälningar manuellt.'
            action={addRegistrationBtn}
          />
        ) : (
          <EmptyState
            headingText={'Din sökning gav inga träffar'}
            bodyText={
              'Kontrollera att stavningen är rätt. Du kan söka efter namn, klubb samt tävlingsklass'
            }
          />
        )}
      </Row>

      <AddRegistrationModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        setShowAddRegistrationSuccess={setShowAddRegistrationSuccess}
        setShowAddRegistrationFail={setShowAddRegistrationFail}
        registrations={registrations}
      />

      <RaceClassBulkModal
        raceClassBulkInfo={raceClassBulkInfo}
        onHide={setRaceClassBulkInfo}
        setRaceClassBulkInfo={setRaceClassBulkInfo}
        competitionId={competitionId}
        setRegistrations={setRegistrations}
        setBatchSelectedRegistrations={setBatchSelectedRegistrations}
        setBulkRaceClassToast={setBulkRaceClassToast}
        selectedElements={batchSelectedRegistrations}
      />

      <CustomToast
        type='success'
        title='Anmälan tillagd'
        body='Anmälan har lagts till'
        show={showAddRegistrationSuccess}
        onClose={() => setShowAddRegistrationSuccess(false)}
      />
      <CustomToast
        type='danger'
        title='Anmälan ej tillagd'
        body='Anmälan kunde inte läggas till'
        show={showAddRegistrationFail}
        onClose={() => setShowAddRegistrationFail(false)}
      />
      <CustomToast
        type='danger'
        title='Misslyckad hämtning'
        body={downloadError}
        show={showDownloadFail}
        onClose={() => setShowDownloadFail(false)}
      />

      <CustomToast
        type='success'
        title={bulkRegistrationStatusesSuccess.headerText}
        body={bulkRegistrationStatusesSuccess.bodyText}
        show={bulkRegistrationStatusesSuccess.show}
        onClose={() =>
          setBulkRegistrationStatusesSuccess({
            ...bulkRegistrationStatusesSuccess,
            show: false,
          })
        }
      />
      <CustomToast
        type='danger'
        title={registrationStatusesFailToast.title}
        body={registrationStatusesFailToast.body}
        show={registrationStatusesFailToast.show}
        onClose={() =>
          setRegistrationStatusesFailToast({
            ...registrationStatusesFailToast,
            show: false,
          })
        }
      />

      <CustomToast
        type={bulkRaceClassToast?.type}
        title={bulkRaceClassToast?.title}
        body={bulkRaceClassToast?.body}
        show={bulkRaceClassToast?.show}
        onClose={() =>
          setBulkRaceClassToast({ ...bulkRaceClassToast, show: false })
        }
      />

      <CustomToast
        type={bulkStartlistToast?.type}
        title={bulkStartlistToast?.title}
        body={bulkStartlistToast?.body}
        show={bulkStartlistToast?.show}
        onClose={() =>
          setBulkStartlistToast({ ...bulkRaceClassToast, show: false })
        }
      />

      <BulkActionMenu
        show={batchSelectedRegistrations.length > 0}
        selectedElements={batchSelectedRegistrations}
        onSelectAll={() => {
          setBatchSelectedRegistrations(registrations);
        }}
        onClose={() => {
          setBatchSelectedRegistrations([]);
        }}
        allElementsCount={registrations?.length}
      >
        <RegistrationBulkMenuBtns
          competitionId={competitionId}
          competitionStatus={competition?.status}
          selectedElements={batchSelectedRegistrations}
          registrations={registrations}
          setRegistrations={setRegistrations}
          setBulkRegistrationStatusesSuccess={
            setBulkRegistrationStatusesSuccess
          }
          setRegistrationStatusesFailToast={setRegistrationStatusesFailToast}
          setRaceClassBulkInfo={setRaceClassBulkInfo}
          raceClassBulkInfo={raceClassBulkInfo}
          setBulkStartlistToast={setBulkStartlistToast}
        />
      </BulkActionMenu>
    </div>
  );
}

export default CompetitionRegistrations;
